import { render } from "./SupportTicketsTable.vue?vue&type=template&id=4be71a09"
import script from "./SupportTicketsTable.vue?vue&type=script&lang=js"
export * from "./SupportTicketsTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__